import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home';
import { EventRegistrationComponent } from './components/event-registration/event-registration';
import { ThankYouComponent } from './components/thank-you/thank-you';
import { environment } from '../environments/environment';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'register', component: EventRegistrationComponent }
];

routes.push({ path: environment.routes.thankYou.replace(/^\//, ''), component: ThankYouComponent });

if (environment.routes.thankYou === '/thank-you') {
  routes.push({ path: 'thanks', component: ThankYouComponent });
} else {
  routes.push({ path: 'thank-you', component: ThankYouComponent });
}

routes.push({ path: '**', redirectTo: '' });

export { routes };
